import React from 'react'

import { PopUpCenterV2 } from 'Component/PopUp';
import IconHelpStock from 'Icon/faq/icon-help-stock.png';
import IconHelpMf from 'Icon/faq/icon-help-mf.png';

import {
  styEmailSupportWrapper,
  styEmailSupportContent,
  styEmailSupportImage,
  styEmailSupportText,
  styEmailSupportTitle
} from './style'

const PopupEmailSupport = ({ emailSupport, isShowPopup, setIsShowPopup }) => (
    <PopUpCenterV2
      show={isShowPopup}
      title="Pilih email bantuan"
      width="612px"
      closeButton
      onHide={() => setIsShowPopup(false)}
    >
      <div className={styEmailSupportWrapper}>
        <div 
          className={styEmailSupportContent}
          onClick={() => {
            window.location.href = `mailto:${emailSupport.stock}`
          }}
        >
          <div className={styEmailSupportImage}>
            <img src={IconHelpStock} alt="icon-help-stock" />
          </div>
          <div className={styEmailSupportText}>
            <span className={styEmailSupportTitle}>Saham</span> 
            <span>
              Dilayani oleh PT Ajaib Sekuritas Asia (Ajaib Sekuritas) berizin <br /> dan diawasi oleh OJK
            </span> 
          </div>
        </div>
        <div 
          className={styEmailSupportContent}
          onClick={() => {
            window.location.href = `mailto:${emailSupport.mutual_fund}`
          }}
        >
          <div className={styEmailSupportImage}>
            <img src={IconHelpMf} alt="icon-help-mf" />
          </div>
          <div className={styEmailSupportText}>
            <span className={styEmailSupportTitle}>Reksa Dana</span> 
            <span>
              Dilayani oleh PT Takjub Teknologi Indonesia (Ajaib Reksadana) <br /> berizin dan diawasi oleh OJK
            </span> 
          </div>
        </div>
      </div>
    </PopUpCenterV2>
  )

export default PopupEmailSupport
